import React, {Component} from 'react';
import _ from "lodash"

class NewSimpleSelect extends Component {
    
    constructor(props) {
        super(props);
        //console.log("NewSimpleSelect::constructor()-> " + this.props.configSearch.id);
        
        this.state = {
            data: props.data || []
        }
        
        // const dataMap = {}
        // this.state.data.map((elem) => {
        //     dataMap[elem.id] = elem.value
        // })
        //
        // this.state.dataMap = dataMap
    }
    
    render() {
        return (
            <div style={this.props.style} id={this.props.configSearch.id} className={this.props.configSearch.collSize}>
                <div htmlFor={this.props.configSearch.id + "-select"} className={"form-group"}>
                    <select id={this.props.configSearch.id + "-select"} className={"form-control select2-form-control"}>
                    </select>
                </div>
            </div>
        );
    }
    
    componentDidMount() {
        //console.log(`NewSimpleSelect::componentDidMount() -> ${this.props.configSearch.id} -> select='${this.props.configSearch.seleccionado}'`);
        //TODO 3/2/23 23:30: para componentDidMount() y componentDidUpdate() : creo que se actualiza el data del slect2
        // cada vez que se pasa por aqui y eso fuerza que se renderice de cero y pierda el css
        let select2Elem = $('#' + this.props.configSearch.id + "-select");
        if (select2Elem) {
            
            let select2 = select2Elem.select2();
            // esta linea es para quinat un span que mete el select2 y que no se necesita, mejor usar el select orginal de html,
            // no hay modal y no se modifica el ancho de pagina
            // document.querySelector("#" + this.props.configSearch.id + " > div > span")?.remove()
            let data
            data = this.props.configSearch.all ? [{id: 0, ...this.props.configSearch.all}].concat(this.props.data) : this.props.data;
            
            data = data.map(elem => {
                let selected = (elem.value === this.props?.configSearch?.seleccionado)
                return {...elem, text: elem.label, selected: selected}
            })
            // $('#' + this.props.configSearch.id + "-select").trigger({
            //     type: 'select2:select',
            //     params: {
            //         data: data
            //     }
            // });
            select2Elem.select2({
                data: data,
                // theme: "classic",
                dropdownParent: $("#" + this.props.configSearch.id),
                placeholder: this.props.configSearch.placeHolder,
                maximumSelectionLength: this.props.configSearch.limit || -1,
            })
            const that = this;
            //Observador de modificación.
            select2.on("change", (e) => {
                const dataObjSelected = select2.select2('data')
                
                // const valueSelected = select.select2('data').map((element) => {
                //     //console.log("select2Data_elementId = '" + element.id + "'");
                //     //console.log("that.state.dataMap[element.id] = '" + that.state.dataMap[element.id] + "'");
                //     // return that.state.dataMap[element.id];
                //     return that.state.dataMap[element.id];
                // })
                // //console.log("valueSelected from state.dataMap = '" + valueSelected + "'");
                //  if (valueSelected) that.props.configSearch.methodChange(valueSelected[0]);
                // //console.log("valueSelected from state.data = '" + that.state.data.find(e => e.label === dataObjSelected[0].text) + "'");
                const elementSelected = that.state.data.find(e => e.label === dataObjSelected[0].text)
                // if (elementSelected) that.props.configSearch.methodChange(elementSelected.value);
                that.props.configSearch.methodChange(elementSelected?.value);
            });
        }
        if (!_.isEqual(this.props.data, this.state.data)) {
            //console.log("this.props.data, this.state.data distintos");
            // const dataMap = {}
            // this.state.data.map((elem) => {
            //     dataMap[elem.id] = elem.value
            // })
            
            // this.state.dataMap = dataMap;
            this.setState({
                data: this.props.data,
                // dataMap: dataMap
            })
            // this.setState({data: this.props.data})
        }
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log(`NewSimpleSelect::componentDidMount() -> ${this.props.configSearch.id} -> select='${this.props.configSearch.seleccionado}'`);
        //TODO 3/2/23 23:30: para componentDidMount() y componentDidUpdate() : creo que se actualiza el data del slect2
        // cada vez que se pasa por aqui y eso fuerza que se renderice de cero y pierda el css
        
        // let select = $('#' + this.props.configSearch.id + "-select");
        // document.querySelector("#" + this.props.configSearch.id + " > div > span")?.remove()
        
        if (prevProps.data?.length !== this.props.data?.length) {
            //console.log("prevProps.data?.length !== this.props.data?.length");
            let data = this.props.configSearch.all ? [{id: 0, ...this.props.configSearch.all}].concat(this.props.data) : this.props.data;
            
            data = data.map(elem => {
                let selected = (elem.value === this.props?.configSearch?.seleccionado)
                return {...elem, text: elem.label, selected: selected}
            })
            let select2Elem = $('#' + this.props.configSearch.id + "-select");
            if (select2Elem) {
                select2Elem.select2()?.empty();
                let that = this;
                select2Elem?.select2({
                    data: data/*.map(elem => ({...elem, text: elem.label}))*/,
                    // theme: "classic",
                    dropdownParent: $("#" + this.props.configSearch.id),
                    placeholder: that.props.configSearch.placeHolder,
                });
            }
        }
        
        
        if (!_.isEqual(this.props.data, this.state.data)) {
            //console.log("this.props.data, this.state.data distintos");
            // const dataMap = {}
            // this.state.data.map((elem) => {
            //     dataMap[elem.id] = elem.value
            // })
            
            // this.state.dataMap = dataMap;
            this.setState({
                data: this.props.data,
                // dataMap: dataMap
            })
        }
        
        
        // if (!_.isEqual(prevProps.configSearch, this.props.configSearch)) {
        //     //console.log("prevProps.configSearch !== this.props.configSearch");
        //
        //     let data = this.props.configSearch.all ? [{id: 0, ...this.props.configSearch.all}].concat(this.props.data) : this.props.data;
        //     // let optionSelected
        //     // if (this.props?.configSearch?.seleccionado) {
        //     data = data.map(elem => {
        //         let selected = (elem.value === this.props?.configSearch?.seleccionado)
        //         // if (selected) optionSelected = new Option(elem.label, elem.id, false, true);
        //         return {...elem, text: elem.label, selected: selected}
        //     })
        //     // } else {
        //     //     data = data.map(elem => {
        //     //         return {...elem, text: elem.label, selected: false}
        //     //     })
        //     //     data[0].selected = true
        //     // optionSelected = new Option(data[0].label, data[0].id, true, true);
        //     // }
        //     //esto finciona pero laznza el evento de seleecion
        //     // $('#' + this.props.configSearch.id + "-select").append(optionSelected).trigger('change');
        //     let that = this;
        //     select.empty();
        //     $('#' + this.props.configSearch.id + "-select").select2({
        //         data: data/*.map(elem => ({...elem, text: elem.label}))*/,
        //         dropdownParent: $("#" + this.props.configSearch.id),
        //         placeholder: that.props.configSearch.placeHolder,
        //     });
        // }
        
        // $('body').on('shown.bs.modal', '.modal', function () {
        //     //console.log("Atencio!!!! reviar para que sirve esto -> $('body').on('shown.bs.modal', '.modal'");
        //     $(this).find('select').each(function () {
        //         //console.log("Atencio!!!! reviar para que sirve esto -> $('body').on('shown.bs.modal', '.modal' -> $(this).find('select').each()");
        //         var dropdownParent = $("#" + this.props.configSearch.id);
        //         if ($(this).parents('.modal.in:first').length !== 0)
        //             dropdownParent = $(this).parents('.modal.in:first');
        //         $(this).select2({
        //             dropdownParent: dropdownParent
        //             // ...
        //         });
        //     });
        // });
        
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default NewSimpleSelect
